import React, { useEffect, useRef, useState } from "react"
import { Link, useLocation, useNavigate, useParams } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap"
import { FormProvider, useFieldArray, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import {
  UFDate,
  UFEditor,
  UFInputNumber,
  UFInput,
} from "../../../components/Common/Fields/Input"
import CurrencyList from "../../../components/Common/chooseFields/currency"
import Country from "../../../components/Common/chooseFields/country"
import PaymentMode from "../../../components/Common/chooseFields/paymentMode"
import LoadingButton from "../../../components/Common/LoadingButton"
import {
  fetchSupplier,
  postSupplier,
} from "../../../services/procurement/supplier"
import uploadicon from "../../../assets/icons/export-light.svg"
import closeIcon from "../../../assets/icons/close.svg"
import PhoneInputField from "../../../components/Common/Fields/phoneInput"
import BankList from "../../../components/Common/chooseFields/bankList"
import DebitCreditDrop from "../../../components/Common/chooseFields/debitCredit"
import CreditPeriod from "../../../components/Common/chooseFields/creditPeriod"
import FinanceGroupType from "../../../components/Common/chooseFields/financeGroupType"
import BalanceTypeDrop from "../../../components/Common/chooseFields/balanceType"
import FinanceLedgersLi from "../../../components/Common/chooseFields/ledgers"
import moment from "moment"
import StateList from "../../../components/Common/chooseFields/stateList"
import UploadArrowIcon from "../../../assets/icons/iconComponents/uploadArrowIcon"
import TrashIcon from "../../../assets/icons/iconComponents/trashIcon"
import { getCode } from "../../../services/inventory"
import EditFinanceGroup from "../../Finance/groups/edit"
import CreditPaymentMethod from "../../../components/Common/chooseFields/creditPayment"

const schema = yup.object().shape({
  name: yup.string().required("Name is Required"),
  // vat_no: yup.string().required("VAT Number is Required"),
  // vat_no: yup.string()
  //   .required("VAT Number is Required")
  //   .matches(/^\d+$/, "VAT Number must only contain numbers")
  //   .min(15, "VAT Number must be at least 15 character")
  //   .max(15, "VAT Number must be at most 15 characters"),
  po_box_no: yup.string().notRequired(),
  code_edit: 0,
  // .required("PO Box No is Required"),
  vat_no: yup
    .string()
    .nullable()
    .notRequired()
    .test(
      "is-valid-vat",
      "VAT Number must only contain numbers and be 15 characters long",
      value => {
        if (!value) return true // Skip validation if the value is empty
        const isNumeric = /^\d+$/.test(value)
        return isNumeric && value.length === 15
      }
    ),
  trade_licence_no: yup.string().nullable().notRequired(),
  // .test(
  //   "is-valid-vat",
  //   "VAT Number must only contain numbers and be 15 characters long",
  //   value => {
  //     if (!value) return true // Skip validation if the value is empty
  //     const isNumeric = /^\d+$/.test(value)
  //     return isNumeric && value.length === 15
  //   }
  // ),

  address: yup
    .string()
    .required()
    .max(255, "Address cannot exceed 255 characters"),
  // .required("Address is Required"),
  // email_id: yup
  //   .string()
  //   .email("Must be a valid Email")
  //   .required("Email ID is Required"),
  email_id: yup
    .string()
    .email("Must be a valid Email")
    .nullable()
    .notRequired(),

  contact_number: yup
    .string()
    .notRequired()
    .test(
      "is-valid-contact",
      "Contact number must be between 10 and 15 digits and can start with +",
      value => {
        if (!value) return true // allow empty (not required)
        const regex = /^\+?[0-9]{10,15}$/
        return regex.test(value)
      }
    ),

  // contact_number: yup
  //   .string()
  //   // .required("Contact Number is Required")
  //   .notRequired()
  //   .matches(/^\+?[0-9]+$/, "Contact Number must contain only digits")
  //   .min(10, "Contact number must be min 10 digits")
  //   .max(15, "Contact number must be max 15 digits"),
  // payment_mode: yup.mixed().required("Payment Mode is Required"),
  creditperiod: yup.mixed().notRequired(),
  // required("Credit Period is Required"),
  country_id: yup.mixed().notRequired(),
  // .required("Country is Required"),
  account_group_id: yup.mixed().required("Nature of Account is Required"),
  // balance_type: yup.mixed().required("Balance Type is Required"),
  // inventory_account_id: yup.mixed().required("Inventory Account is Required"),
  // vat_account_id: yup.mixed().required("VAT Account is Required"),
  // accounts_payable_id: yup.mixed().required("Payable Account is Required"),
  // opening_balance: yup
  //   .string()
  //   .matches(/^\d+$/, "Opening Balance must only contain numbers"),
  opening_balance: yup
    .string()
    .test(
      "empty-or-valid",
      "Opening Balance must only contain numbers",
      value => {
        // Allow empty string or null
        if (value === "" || value === null) return true
        // Validate numeric values with optional decimal
        return /^\d+(\.\d{1,2})?$/.test(value)
      }
    )
    .nullable()
    .notRequired(),

  voucher_contra_partial_pay: yup
      .array()
      .of(
        yup.object().shape({
          code: yup.string().trim().required("Reference Number is Required"),
          amount: yup
            .number()
            .typeError("Amount must be a number")
            .min(0, "Amount must be a positive number")
            .transform(value => (isNaN(value) ? undefined : value)),
          date: yup
            .date()
            .typeError("Date must be a valid date")
            .required("Date is Required"),
          due_date: yup
            .date()
            .typeError("Due Date must be a valid date")
            .required("Due Date is Required"),
        })
      )
      .when(["opening_balance", "account_group_id"], {
        is: (opening_balance, account_group_id) =>
          opening_balance > 0 && [13, 22].includes(account_group_id),
        then: schema => schema.min(1, "At least one partial payment is required"),
        otherwise: schema => schema.notRequired(),
      }),

  currency_id: yup.mixed().notRequired(),
  // .required("Currency is Required"),
  bank_details: yup.array().of(
    yup.object().shape({
      ac_holder_name: yup.string(),
      // .required("Account Holder name is Required"),
      ac_number: yup.string(),
      // .required("Account Number is required"),
      bank_name: yup.mixed().nullable(),
      // .required("Bank Name is required"),
      branch_name: yup.string(),
      // .required("Branch Name is required"),
      iban: yup.string(),
      // .required("IBAN is required"),
      swift_code: yup.string(),
      // .required("Swift Code is required"),
    })
  ),
  contact_person: yup.array().of(
    yup.object().shape({
      email_id: yup.string().email("Must be a valid Email").notRequired(),
      // .required("Email is Required"),
      designation: yup.string().notRequired(),
      // .required("Designation is Required"),
      phone_no: yup
        .string()
        .matches(/^([+]?)?[0-9]+$|^$/, "Phone Number must be only digits")
        .max(15, "Maximum limit is 15")
        .notRequired(),
      // .required("Phone Number is Required"),
      supplier_contact_name: yup.string().notRequired(),
      // .required("Supplier contact Name is required"),
    })
  ),
})

const EditSupplier = ({ formId = "supplier-form", isOpen = false, }) => {
  const navigate = useNavigate()
  const { id } = useParams()
  const drCrRefs = useRef([])
  const desimalrange = localStorage.getItem("desimalrange")

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""

  const companyname = localStorage.getItem("companyname")
  document.title = `Supplier${companyname ? ` | ${companyname}` : "MEP -Hub"}`

  const [isLoading, setIsLoading] = useState(false)
  const [vatFile, setVatFile] = useState()
  const [vendorFile, setVendorFile] = useState()
  const [tradeFile, setTradeFile] = useState()
  const [isChecked, setIsChecked] = useState()
  const [isModal, setModal] = useState(false)
  const [veRemove, setVERemove] = useState([])

  const now = moment()

  const [showGroupModal, setShowGroupModal] = useState(false)

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      name: "",
      email_id: "",
      payment_mode: null,
      creditperiod: null,
      contact_number: "",
      country_id: null,
      account_group_id: null,
      balance_type: null,
      balance_type: null,
      opening_balance: 0,
      // inventory_account_id: null,
      // vat_account_id: null,
      // accounts_payable_id: null,
      vat_no: "",
      trade_licence_no: "",
      po_box_no: "",
      currency_id: null,
      is_subcontractor: false,
      address: "",
      trade_document: null,
      vat_document: null,
      vendor_document: null,
      bank_details: [
        {
          ac_holder_name: "",
          ac_number: "",
          bank_name: null,
          branch_name: "",
          iban: "",
          swift_code: "",
        },
      ],
      contact_person: [
        {
          email_id: "",
          designation: "",
          phone_no: "",
          supplier_contact_name: "",
        },
      ],
    },
  })
  const methods = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    shouldFocusError: true,
  })

  const getUniqueCode = async (code, modal, type) => {
    const response = await getCode(code, modal, type)
    if (!id) {
      setValue("suppliers_code", response?.code?.code)
    }
    setValue("code_edit", response?.code?.manualoverride)
  }
  useEffect(() => {
    const handleFetchSupplier = async () => {
      const response = await fetchSupplier(id)
      console.log("fetch", response)
      const bankDetails = response?.data?.bank_details?.map(dt => ({
        id: dt?.id,
        ac_holder_name: dt?.ac_holder_name,
        ac_number: dt?.ac_number,
        bank_name: {
          label: dt?.banks?.label,
          value: dt?.banks?.id,
          id: dt?.banks?.id,
        },
        branch_name: dt?.branch_name,
        iban: dt?.iban,
        swift_code: dt?.swift_code,
      }))
      const contactPersons = response?.data?.contact?.map(contact => ({
        id: contact?.id,
        email_id: contact?.email_id,
        designation: contact?.designation,
        phone_no: contact?.phone_no,
        supplier_contact_name: contact?.supplier_contact_name,
      }))
      reset({
        id: id,
        suppliers_code: response?.data?.suppliers_code,
        name: response?.data?.name,
        email_id: response?.data?.email_id,
        contact_number:
          response?.data?.contact_number == null
            ? ""
            : response?.data?.contact_number,
        vat_no: response?.data?.vat_no,
        trade_licence_no: response?.data?.trade_licence_no,
        po_box_no: response?.data?.po_box_no,
        address: response?.data?.address,
        is_subcontractor: response?.data?.is_subcontractor === 1 ? true : false,
        vat_document_expiry_date: response?.data?.vat[0]?.expiry_date,
        trade_document_expiry_date: response?.data?.trade[0]?.expiry_date,
        account_group_id: {
          value: response?.data?.account_group?.id,
          label: response?.data?.account_group?.name,
        },
        // inventory_account_id: {
        //   value: response?.data?.inventory_account?.id,
        //   label: response?.data?.inventory_account?.name,
        // },
        // vat_account_id: {
        //   value: response?.data?.vat_account?.id,
        //   label: response?.data?.vat_account?.name,
        // },
        // accounts_payable_id: {
        //   value: response?.data?.accounts_payable?.id,
        //   label: response?.data?.accounts_payable?.name,
        // },
        payment_mode: {
          value: response?.data?.payment?.id,
          label: response?.data?.payment?.name,
        },
        creditperiod: response?.data?.credit_period?.id ? {
                value: response?.data?.credit_period?.id,
                id: response?.data?.credit_period?.id,
                label:
                  response?.data?.credit_period?.period == 0
                    ? "Immediate"
                    : `${response?.data?.credit_period?.period} ${
                        response?.data?.credit_period?.unit == "days"
                          ? response?.data?.credit_period?.period > 1
                            ? "Days"
                            : "Day"
                          : response?.data?.credit_period?.period > 1
                          ? "Months"
                          : "Months"
                      }`,
                ...response?.data?.credit_period,
              } : null,
        country_id: {
          value: response?.data?.country?.id,
          label: response?.data?.country?.name,
        },
        country_id_1: {
          value: response?.data?.country?.country?.id,
          label: response?.data?.country?.country?.name,
        },
        currency_id: {
          value: response?.data?.currency?.id,
          label: response?.data?.currency?.currency_code,
        },
        balance_type: {
          value: response?.data?.ledger?.balance_type,
          label:
            response?.data?.ledger?.balance_type == "debit"
              ? "Debit"
              : "Credit",
        },
        opening_balance: response?.data?.ledger?.opening_balance,
        // bank_details: [...response?.data?.bank_details],
        bank_details: bankDetails?.length
          ? bankDetails
          : [
            {
              ac_holder_name: "",
              ac_number: "",
              bank_name: null,
              branch_name: "",
              iban: "",
              swift_code: "",
            },
          ],
        contact_person: contactPersons?.length // Use the mapped contact persons data
          ? contactPersons
          : [
            {
              email_id: "",
              designation: "",
              phone_no: "",
              supplier_contact_name: "",
            },
          ],
      })
      setTradeFile(response?.data?.trade?.[0]?.file_path?.split("/").pop())
      setVatFile(response?.data?.vat?.[0]?.file_path?.split("/").pop())
      setVendorFile(response?.data?.vendor_document)
      setIsChecked(response?.data?.is_subcontractor === 1 ? true : false)
    }

    if (id) {
      handleFetchSupplier()
    }
    // if (!id) {
    getUniqueCode("suppliers_code", "Suppliers", "Suppliers")
    // }
  }, [id])

  const handleRegistration = async data => {
    console.log(`data`, data)
    console.log("checking", data?.opening_balance > 0)

    const totalCheck = calculateCreditDebitDifference(
      data?.voucher_contra_partial_pay || []
    )

    if (Number(data?.opening_balance) > 0 && !isModal) {
      setModal(true)
      if (
        Number(data?.opening_balance) -
        Number(
          data?.balance_type?.value == "debit"
            ? Number(totalCheck?.totalDebit || 0) -
            Number(totalCheck?.totalCredit || 0)
            : Number(totalCheck?.totalCredit || 0) -
            Number(totalCheck?.totalDebit || 0)
        ) !=
        0
      ) {
        contraPartialListAppend({
          account_id: data?.credit_id?.value,
          debit: 0,
          credit: 0,
          amount: Math.abs(
            Number(watch("opening_balance")) -
            // Number(totalCheck?.difference || 0)
            Number(
              data?.balance_type?.value == "debit"
                ? Number(totalCheck?.totalDebit || 0) -
                Number(totalCheck?.totalCredit || 0)
                : Number(totalCheck?.totalCredit || 0) -
                Number(totalCheck?.totalDebit || 0)
            )
          ).toFixed(desimalrange || 2),
          type: data?.balance_type?.value
            ? {
              label: data?.balance_type?.value == "debit" ? "Dr" : "Cr",
              value: data?.balance_type?.value,
            }
            : { label: "Cr", value: "credit" },
          // Number(data?.opening_balance) < Number(totalCheck?.difference)
          //   ? { label: "Dr", value: "debit" }
          //   : { label: "Cr", value: "credit" },
          due_date: moment(now, "DD-MM-MMMM").toDate(),
          date: moment("31-12-2024", "DD-MM-YYYY").toDate(),
          ref_id: {
            label: "New Ref",
            value: 3,
          },
        })
      }
    } else if (
      Number(data?.opening_balance || 0) -
      Number(
        data?.balance_type?.value == "debit"
          ? Number(totalCheck?.totalDebit || 0) -
          Number(totalCheck?.totalCredit || 0)
          : Number(totalCheck?.totalCredit || 0) -
          Number(totalCheck?.totalDebit || 0)
      ) !=
      0 &&
      isModal
    ) {
      // setModal(true)
      if (
        Number(data?.opening_balance) -
        Number(
          data?.balance_type?.value == "debit"
            ? Number(totalCheck?.totalDebit || 0) -
            Number(totalCheck?.totalCredit || 0)
            : Number(totalCheck?.totalCredit || 0) -
            Number(totalCheck?.totalDebit || 0)
        ) !=
        0
      ) {
        contraPartialListAppend({
          account_id: data?.credit_id?.value,
          debit: 0,
          credit: 0,
          amount: Math.abs(
            Number(watch("opening_balance")) -
            // Number(totalCheck?.difference || 0)
            Number(
              data?.balance_type?.value == "debit"
                ? Number(totalCheck?.totalDebit || 0) -
                Number(totalCheck?.totalCredit || 0)
                : Number(totalCheck?.totalCredit || 0) -
                Number(totalCheck?.totalDebit || 0)
            )
          ).toFixed(desimalrange || 2),
          type:
            data?.balance_type?.value == "debit" &&
              Number(totalCheck?.totalDebit || 0) <
              Number(data?.opening_balance || 0)
              ? { label: "Dr", value: "debit" }
              : data?.balance_type?.value == "credit" &&
                Number(totalCheck?.totalCredit || 0) <
                Number(data?.opening_balance || 0)
                ? { label: "Cr", value: "credit" }
                : data?.balance_type?.value == "debit" &&
                  Number(totalCheck?.totalDebit || 0) >
                  Number(data?.opening_balance || 0)
                  ? { label: "Cr", value: "credit" }
                  : { label: "Dr", value: "debit" },

          // Number(data?.opening_balance) < Number(totalCheck?.difference)
          //   ? { label: "Dr", value: "debit" }
          //   : { label: "Cr", value: "credit" },
          // type:
          //   Number(data?.opening_balance) < Number(totalCheck?.difference)
          //     ? { label: "Dr", value: "debit" }
          //     : { label: "Cr", value: "credit" },
          due_date: moment(now, "DD-MM-MMMM").toDate(),
          date: moment("31-12-2024", "DD-MM-YYYY").toDate(),
          ref_id: {
            label: "New Ref",
            value: 3,
          },
        })
      }
    }
    else {

      const voucherEntry = data?.voucher_contra_partial_pay?.map(item => ({
              voucher_id: 20,
              ref_number: item?.code,
              due_date: moment(item?.due_date).format("YYYY-MM-DD"),
              date: moment(item?.date).format("YYYY-MM-DD"),
              amount: item?.amount,
              type: item?.type?.value,
              voucherType: "Opening Balance",
              voucher_entry_id: item?.voucher_entry_id,
            }))

      const bank_details_arr = data?.bank_details
        ?.map(dt => {
          const details = {
            ac_holder_name: dt?.ac_holder_name,
            ac_number: dt?.ac_number,
            bank_name: dt?.bank_name?.id,
            branch_name: dt?.branch_name,
            iban: dt?.iban,
            swift_code: dt?.swift_code,
            id: id ? dt?.id : "",
          }

          // Remove keys with falsy values (null, undefined, empty string)
          return Object.fromEntries(
            Object.entries(details).filter(
              ([_, value]) => value != null && value !== ""
            )
          )
        })
        .filter(obj => Object.keys(obj).length > 0) // Remove empty objects

      const { bank_details, ...updatedData } = data

      const validContacts = data?.contact_person.filter(
        person => person.supplier_contact_name !== null
      )

      try {
        setIsLoading(true)
        const updateDepartment = await postSupplier({
          ...updatedData,
          ...(bank_details_arr?.length > 0 && {
            bank_details: bank_details_arr,
          }),
          // ...(validContacts?.length > 0 && {
          contact_person: validContacts,
          voucherEntry: voucherEntry,
          // }),
          is_subcontractor: data?.is_subcontractor ? 1 : 0,
          payment_mode: data?.payment_mode?.value,
          creditperiod: data?.creditperiod?.id,
          country_id: data?.country_id?.value,
          currency_id: data?.currency_id?.value,
          account_group_id: data?.account_group_id?.value,
          balance_type: data?.balance_type?.value,
          opening_balance: data?.opening_balance ? data?.opening_balance : 0,
          vat_document_expiry_date: data?.vat_document_expiry_date
            ? moment(data?.vat_document_expiry_date).format("YYYY-MM-DD")
            : "",
          trade_document_expiry_date: data?.trade_document_expiry_date
            ? moment(data?.trade_document_expiry_date).format("YYYY-MM-DD")
            : "",
          // inventory_account_id: data?.inventory_account_id?.value,
          // vat_account_id: data?.vat_account_id?.value,
          // accounts_payable_id: data?.accounts_payable_id?.value,
          ...(typeof vatFile != "string" && { vat_document: vatFile }),
          ...(typeof tradeFile != "string" && { trade_document: tradeFile }),
          ...(typeof vendorFile != "string" && { vendor_document: vendorFile }),
        })
        navigate("/procurement-supplier")
        toastSuccess(updateDepartment?.message)
      } catch (err) {
        toastError(err?.message)
      } finally {
        setIsLoading(false)
        // }
      }
    }
    // if (!id && !vatFile && !tradeFile) {
    // // if (!id) {
    //   if (!vatFile) {
    //     toastError("VAT file is Required")
    //   }
    //   if (!tradeFile) {
    //     toastError("Trade file is Required")
    //   }
    // } else {
    // const bank_details = data?.bank_details?.map(dt => ({
    //   ac_holder_name: dt?.ac_holder_name,
    //   ac_number: dt?.ac_number,
    //   bank_name: dt?.bank_name?.id,
    //   branch_name: dt?.branch_name,
    //   iban: dt?.iban,
    //   swift_code: dt?.swift_code,
    //   id: id ? dt?.id : "",
    // }))
  }

  const {
    fields: contraFieldsPartial,
    append: contraPartialListAppend,
    remove: contraPartialListRemove,
  } = useFieldArray({
    control,
    name: "voucher_contra_partial_pay",
  })

  const handlePartialRemove = e => {
    setVERemove(prevVERemove => [...prevVERemove, e])
  }

  const toggleSelect = () => setModal(!isModal)

  const toggleSelectModal = () => {

    if (!id) {
      setValue(`voucher_contra_partial_pay`, [])
    }

    const removeIds = watch("voucher_contra_partial_pay")?.map((_, i) => i)

    if (removeIds?.length > 1) {
      ;[...removeIds].reverse().forEach(index => contraPartialListRemove(index))
    }

    console.log(`removeIds`, removeIds)
    setModal(!isModal)
  }

  const {
    fields: contactFields,
    append: contactAppend,
    remove: contactRemove,
  } = useFieldArray({
    control,
    name: "contact_person",
  })
  const {
    fields: accountFields,
    append: accountAppend,
    remove: accountRemove,
  } = useFieldArray({
    control,
    name: "bank_details",
  })

  const onVatChange = event => {
    setVatFile(event?.target?.files?.[0])
  }
  const onVendorChange = event => {
    setVendorFile(event?.target?.files?.[0])
  }

  const onTradeChange = event => {
    setTradeFile(event?.target?.files?.[0])
  }
  const handleCheck = e => {
    if (e?.target?.checked) {
      setValue("is_subcontractor", true)
      getUniqueCode("suppliers_code", "Suppliers", "Subcontract")
    } else {
      setValue("is_subcontractor", false)
      getUniqueCode("suppliers_code", "Suppliers", "Suppliers")
    }
  }

  const handleBank = (e, i) => {
    console.log(`bankk`, e)
    setValue(`bank_details.${i}.iban`, e?.iban_code ? e?.iban_code : "")
    setValue(`bank_details.${i}.swift_code`, e?.swift_code ? e?.swift_code : "")
  }
  const handleCancel = () => {
    navigate("/procurement-supplier")
  }

  const calculateCreditDebitDifference = (entries = []) => {
    let totalCredit = 0
    let totalDebit = 0

    entries.forEach(({ amount = 0, type }) => {
      const amt = Number(amount) || 0
      const typeChk = type?.value

      if (typeChk === "credit") {
        totalCredit += amt
      } else if (typeChk === "debit") {
        totalDebit += amt
      }
    })

    totalCredit = Number(totalCredit.toFixed(desimalrange || 2))
    totalDebit = Number(totalDebit.toFixed(desimalrange || 2))
    const difference = Number(
      Math.abs(totalCredit - totalDebit).toFixed(desimalrange || 2)
    )

    return {
      totalCredit,
      totalDebit,
      difference,
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <FormProvider {...methods}>
            <Form
              id={`supplier-form`}
              onSubmit={(e) => {
                e.preventDefault()
                e.stopPropagation()
                handleSubmit(handleRegistration)(e)
              }
              }
            >
              <div className="sticky-top w-100">
                <div className="d-flex justify-content-between pe-3">
                  <Breadcrumbs
                    title="Procurement"
                    breadcrumbObject={[
                      { title: "Procurement", link: "/procurement" },
                      { title: crumb || "Masters", link: "/procurement" },
                      { title: "Suppliers", link: "/procurement-supplier" },
                      {
                        title: id ? "Edit Suppliers" : "Add Suppliers",
                        link: "",
                      },
                    ]}
                  />
                  <div className="d-flex gap-2">
                    <LoadingButton
                      form={`supplier-form`}
                      color={"secondary"}
                      disabled={isLoading}
                      className={"px-2 mb-3 btn btn-secondary"}
                      type="button"
                      onClick={handleCancel}
                    >
                      Cancel
                    </LoadingButton>
                    <LoadingButton
                      form={`supplier-form`}
                      color={"primary"}
                      loading={isLoading}
                      disabled={isLoading}
                      className={"px-2 mb-3 btn btn-primary"}
                      type="submit"
                    >
                      {id ? "Update" : "Save"}
                    </LoadingButton>
                  </div>
                </div>
              </div>
              <Container fluid className="ps-lg-0">
                <Card className="invoice-main-card p-3 pt-4">
                  <Row className="mb-0 mt-2">
                    <Col sm={3}>
                      <FormGroup className="mb-3">
                        <Label>Supplier Code</Label>
                        <UFInput
                          control={control}
                          placeholder=""
                          name={"suppliers_code"}
                          invalid={!!errors.suppliers_code}
                          disabled={
                            watch("code_edit") == 0 ||
                              watch("code_edit") == undefined
                              ? true
                              : false
                          }
                        />
                        <FormFeedback invalid>
                          {errors.suppliers_code?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col sm={3}>
                      <FormGroup className="mb-3">
                        <Label>
                          Supplier Name<span className="mandatory">*</span>
                        </Label>
                        <UFInput
                          control={control}
                          placeholder="Enter the Supplier Name"
                          name={"name"}
                          invalid={!!errors.name}
                        />
                        <FormFeedback invalid>
                          {errors.name?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col sm={3}>
                      <FormGroup className="mb-3">
                        <Label>Email ID</Label>
                        <UFInput
                          control={control}
                          placeholder="Enter the Email ID"
                          name={"email_id"}
                          invalid={!!errors.email_id}
                        />
                        <FormFeedback invalid>
                          {errors.email_id?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    {/* <Col sm={3}>
                      <FormGroup className="mb-3">
                        <Label>
                          Payment Mode<span className="mandatory">*</span>
                        </Label>
                        <PaymentMode
                          control={control}
                          placeholder="select"
                          name={"payment_mode"}
                          invalid={!!errors.payment_mode}
                          target={"body"}
                        />
                        <FormFeedback invalid>
                          {errors.payment_mode?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col> */}
                    <Col sm={3}>
                      <FormGroup className="mb-3">
                        <Label>
                          Credit Period
                          {/* <span className="mandatory">*</span> */}
                        </Label>
                        <CreditPaymentMethod
                          control={control}
                          placeholder="Select the Credit Period"
                          name={"creditperiod"}
                          invalid={!!errors.creditperiod}
                          target={"body"}
                        />
                        <FormFeedback invalid>
                          {errors.creditperiod?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col sm={3}>
                      <FormGroup className="mb-3">
                        <Label>
                          Contact Number
                          {/* <span className="mandatory">*</span> */}
                        </Label>
                        {/* <UFInput
                              control={control}
                              placeholder="Enter the Contact Number"
                              name={"contact_number"}
                              invalid={!!errors.contact_number}
                            /> */}
                        <PhoneInputField
                          control={control}
                          name={"contact_number"}
                          invalid={!!errors.contact_number}
                        />
                        <FormFeedback invalid>
                          {errors.contact_number?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col sm={3}>
                      <FormGroup className="mb-4">
                        <Label>
                          Country
                          {/* <span className="mandatory">*</span> */}
                        </Label>
                        <Country
                          control={control}
                          placeholder="Select the Country"
                          name={"country_id_1"}
                          invalid={!!errors.country_id_1}
                          target={"body"}
                        />
                        <FormFeedback invalid>
                          {errors.country_id_1?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col sm={3}>
                      <FormGroup className="mb-4">
                        <Label>
                          State
                          {/* <span className="mandatory">*</span> */}
                        </Label>
                        <StateList
                          control={control}
                          placeholder="Select the State"
                          name={"country_id"}
                          selectedCountry={watch("country_id_1")}
                        />
                        <FormFeedback invalid>
                          {errors.country_id?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col sm={3}>
                      <FormGroup className="mb-4">
                        <Label>
                          Currency
                          {/* <span className="mandatory">*</span> */}
                        </Label>
                        <CurrencyList
                          control={control}
                          placeholder="Select the Currency"
                          name={"currency_id"}
                          invalid={!!errors.currency_id}
                          target={"body"}
                        />
                        <FormFeedback invalid>
                          {errors.currency_id?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col sm={3}>
                      <FormGroup className="mb-4">
                        <Label>
                          VAT No
                          {/* <span className="mandatory">*</span> */}
                        </Label>
                        <UFInput
                          control={control}
                          placeholder="Enter the VAT No"
                          rows="3"
                          name={"vat_no"}
                          invalid={!!errors.vat_no}
                        />
                        <FormFeedback invalid>
                          {errors.vat_no?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col sm={3}>
                      <FormGroup className="mb-4">
                        <Label>
                          Trade Licence No
                          {/* <span className="mandatory">*</span> */}
                        </Label>
                        <UFInput
                          control={control}
                          placeholder="Enter the Trade Licence No"
                          rows="3"
                          name={"trade_licence_no"}
                          invalid={!!errors.trade_licence_no}
                        />
                        <FormFeedback invalid>
                          {errors.trade_licence_no?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    {/* <Col sm={3}>
                      <FormGroup className="mb-4">
                        <Label>
                          VAT Expiry Date
                        </Label>
                        <UFDate
                          control={control}
                          name={"vat_document_expiry_date"}
                          invalid={!!errors.vat_document_expiry_date}
                        />
                        <FormFeedback invalid>
                          {errors.vat_document_expiry_date?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col> */}
                    <Col sm={3}>
                      <FormGroup className="mb-4">
                        <Label>
                          Trade Expiry Date
                          {/* <span className="mandatory">*</span> */}
                        </Label>
                        <UFDate
                          control={control}
                          name={"trade_document_expiry_date"}
                          invalid={!!errors.trade_document_expiry_date}
                        />
                        <FormFeedback invalid>
                          {errors.trade_document_expiry_date?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col sm={3}>
                      <FormGroup className="mb-4">
                        <Label>
                          PO Box No
                          {/* <span className="mandatory">*</span> */}
                        </Label>
                        <UFInput
                          control={control}
                          placeholder="Enter the PO Box No"
                          rows="3"
                          name={"po_box_no"}
                          invalid={!!errors.po_box_no}
                        />
                        <FormFeedback invalid>
                          {errors.po_box_no?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col lg={3}>
                      <FormGroup className="mb-4">
                        <Label>Address</Label>
                        <span className="mandatory">*</span>
                        <UFEditor
                          control={control}
                          placeholder="Enter the Address"
                          rows="5"
                          name={"address"}
                          invalid={!!errors.address}
                          className={"pb-0"}
                        />
                        <FormFeedback invalid>
                          {errors.address?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col lg={3}>
                      <FormGroup className="mb-4">
                        <Label>Trade Licence</Label>

                        <Col className="file-import-div import-light p-4 hgt-145">
                          <label
                            htmlFor="trade_document"
                            className="m-0 pointer w-100"
                          >
                            <input
                              type="file"
                              id="trade_document"
                              name="trade_document"
                              accept=".pdf"
                              onChange={event => {
                                onTradeChange(event)
                              }}
                            />

                            <div className="d-flex justify-content-center pb-2 supplier-doc">
                              {/* <img
                                src={uploadicon}
                                alt="Export-light"
                                className="Export-light "
                              /> */}
                              <UploadArrowIcon />
                            </div>
                            {tradeFile ? (
                              <div className="d-flex justify-content-center secondary-text">
                                <span className="file-up-txt">
                                  {/* {tradeFile?.name || "Trade.pdf"} */}
                                  {tradeFile?.name?.length > 50
                                    ? "..." + tradeFile?.name.slice(-20)
                                    : tradeFile?.name || "Trade.pdf"}
                                </span>
                              </div>
                            ) : (
                              <>
                                <div className="d-flex justify-content-center secondary-text">
                                  <span className="upload">Upload&nbsp;</span>
                                  <span className="file-up-txt">
                                    Trade Document
                                  </span>
                                </div>
                              </>
                            )}
                          </label>
                        </Col>
                        <FormFeedback invalid>
                          {errors.trade_document?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col lg={3}>
                      <FormGroup className="mb-4">
                        <Label>VAT Certificate</Label>
                        <Col className="file-import-div import-light p-4 hgt-145">
                          <label
                            htmlFor="vat_document"
                            className="m-0 pointer w-100"
                          >
                            <input
                              type="file"
                              id="vat_document"
                              name="vat_document"
                              accept=".pdf"
                              onChange={event => {
                                onVatChange(event)
                              }}
                            />

                            <div className="d-flex justify-content-center pb-2 supplier-doc">
                              {/* <img
                                src={uploadicon}
                                alt="Export-light"
                                className="Export-light "
                              /> */}
                              <UploadArrowIcon />
                            </div>
                            {vatFile ? (
                              <div className="d-flex justify-content-center secondary-text">
                                <span className="file-up-txt">
                                  {vatFile?.name?.length > 50
                                    ? "..." + vatFile?.name.slice(-20)
                                    : vatFile?.name || "Vat.pdf"}
                                  {/* {vatFile?.name || "Vat.pdf"} */}
                                </span>
                              </div>
                            ) : (
                              <>
                                <div className="d-flex justify-content-center secondary-text">
                                  <span className="upload">Upload&nbsp;</span>
                                  <span className="file-up-txt">
                                    VAT Certificate
                                  </span>
                                </div>
                              </>
                            )}
                          </label>
                        </Col>
                        <FormFeedback invalid>
                          {errors.vat_document?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col lg={3}>
                      <FormGroup className="mb-4">
                        <Label>
                          Vendor Assessment
                          {/* <span className="mandatory">*</span> */}
                        </Label>
                        <Col className="file-import-div import-light p-4 hgt-145">
                          <label
                            htmlFor="vendor_document"
                            className="m-0 pointer w-100"
                          >
                            <input
                              type="file"
                              id="vendor_document"
                              name="vendor_document"
                              accept=".pdf"
                              onChange={event => {
                                onVendorChange(event)
                              }}
                            />

                            <div className="d-flex justify-content-center pb-2 supplier-doc">
                              {/* <img
                                src={uploadicon}
                                alt="Export-light"
                                className="Export-light "
                              /> */}
                              <UploadArrowIcon />
                            </div>
                            {vendorFile ? (
                              <div className="d-flex justify-content-center secondary-text">
                                <span className="file-up-txt">
                                  {/* {vendorFile?.name || "Vendor.pdf"} */}
                                  {vendorFile?.name?.length > 50
                                    ? "..." + vendorFile?.name.slice(-20)
                                    : vendorFile?.name || "Vendor.pdf"}
                                </span>
                              </div>
                            ) : (
                              <>
                                <div className="d-flex justify-content-center secondary-text">
                                  <span className="upload">Upload&nbsp;</span>
                                  <span className="file-up-txt">
                                    Vendor Assessment
                                  </span>
                                </div>
                              </>
                            )}
                          </label>
                        </Col>
                        <FormFeedback invalid>
                          {errors.vendor_document?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>

                    {/* <Col lg={8}>
                      <Row></Row> */}
                    {/* <Row>
                        <Col sm={6}>
                          <FormGroup className="mb-4">
                            <Label>
                              VAT No<span className="mandatory">*</span>
                            </Label>
                            <UFInput
                              control={control}
                              placeholder="Enter the VAT No"
                              rows="3"
                              name={"vat_no"}
                              invalid={!!errors.vat_no}
                            />
                            <FormFeedback invalid>
                              {errors.vat_no?.message}
                            </FormFeedback>
                          </FormGroup>
                        </Col>
                      </Row> */}
                    {/* </Col> */}

                    <Col sm={12}>
                      <FormGroup>
                        <input
                          control={control}
                          type="checkbox"
                          className="ever-rise-checkbox"
                          name={"is_subcontractor"}
                          onChange={e => handleCheck(e)}
                          disabled={id ? true : false}
                          checked={id && isChecked}
                        />
                        <Label className="ms-2"> Sub Contract</Label>
                      </FormGroup>
                    </Col>
                  </Row>
                  {console.log(
                    `is_subcontractor`,
                    watch("is_subcontractor"),
                    isChecked
                  )}

                  {/* <hr className="m-0" /> */}
                  <Row className="py-2">
                    <div className="d-flex align-items-center">
                      <div className="text-extra-high fw-500 font-16 wdt-12">
                        Account Detail
                      </div>
                      {/* <hr className="m-0 mt-2 w-100" /> */}
                      <div className="w-100 div-line"></div>
                    </div>
                  </Row>
                  <Row className="mb-4">
                    {/* <Col lg={3}>
                      <FormGroup>
                        <Label>
                          Nature Of Account
                          <span className="mandatory">*</span>
                        </Label>
                        <FinanceGroupType
                          control={control}
                          placeholder="select"
                          name={"account_group_id"}
                          invalid={!!errors.account_group_id}
                          target={"body"}
                        />
                        <FormFeedback invalid>
                          {errors.account_group_id?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col> */}
                    <Col lg={3}>
                      <FormGroup className="mb-4">
                        <Label>Opening Balance</Label>
                        <UFInput
                          control={control}
                          placeholder="Enter the Opening Balance"
                          name={"opening_balance"}
                          invalid={!!errors.opening_balance}
                        />
                        <FormFeedback invalid>
                          {errors.opening_balance?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col lg={3}>
                      <FormGroup>
                        <Label>Balance Type</Label>
                        <BalanceTypeDrop
                          control={control}
                          placeholder="Select the Balance Type"
                          name={"balance_type"}
                          invalid={!!errors.balance_type}
                        />
                        <FormFeedback invalid>
                          {errors.balance_type?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col lg={3}>
                      <FormGroup>
                        <Label>
                          Nature Of Account
                          <span className="mandatory">*</span>
                        </Label>
                        <FinanceGroupType
                          control={control}
                          placeholder="Select the Nature Of Account"
                          name={"account_group_id"}
                          invalid={!!errors.account_group_id}
                          target={"body"}
                          showCreateOption={true}
                          onCreate={() => setShowGroupModal(true)}
                          // onSelectChange={e => handleNOA(e)}
                          refreshKey={showGroupModal}
                          parentChk={"30"}
                        />
                        <EditFinanceGroup
                          buttonLabel=""
                          className=""
                          show={showGroupModal}
                          onReset={() => setShowGroupModal(false)}
                          onUpdate={newGroup => {
                            setShowGroupModal(false)
                            if (newGroup) {
                              setValue(
                                "account_group_id",
                                {
                                  label: newGroup.name,
                                  value: newGroup.id,
                                },
                                { shouldValidate: true }
                              )
                            }
                          }}
                        />
                        <FormFeedback invalid>
                          {errors.account_group_id?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                  </Row>
                  {/* <hr className="m-0" />
                  <Row className="py-4 mt-4">
                    <h5>Other Accounts</h5>
                  </Row>
                  <Row className="mb-4">
                    <Col lg={3}>
                      <FormGroup>
                        <Label>
                          Inventory Account
                          <span className="mandatory">*</span>
                        </Label>
                        <FinanceLedgersLi
                          control={control}
                          placeholder="select"
                          name={"inventory_account_id"}
                          invalid={!!errors.inventory_account_id}
                          target={"body"}
                          filSupplier={id}
                        />
                        <FormFeedback invalid>
                          {errors.inventory_account_id?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col lg={3}>
                      <FormGroup>
                        <Label>
                          Payable Account
                          <span className="mandatory">*</span>
                        </Label>
                        <FinanceLedgersLi
                          control={control}
                          placeholder="select"
                          name={"accounts_payable_id"}
                          invalid={!!errors.accounts_payable_id}
                          target={"body"}
                          filSupplier={id}
                        />
                        <FormFeedback invalid>
                          {errors.accounts_payable_id?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col lg={3}>
                      <FormGroup>
                        <Label>
                          VAT Account
                          <span className="mandatory">*</span>
                        </Label>
                        <FinanceLedgersLi
                          control={control}
                          placeholder="select"
                          name={"vat_account_id"}
                          invalid={!!errors.vat_account_id}
                          target={"body"}
                          filSupplier={id}
                        />
                        <FormFeedback invalid>
                          {errors.vat_account_id?.message}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                  </Row> */}
                  {/* <hr className="m-0" /> */}
                  <Row className="py-2 mb-2">
                    {/* <h5>Contact Person</h5> */}
                    <div className="d-flex align-items-center">
                      <div className="text-extra-high fw-500 font-16 wdt-12">
                        Contact Person
                      </div>
                      <div className="w-100 div-line"></div>
                    </div>
                  </Row>
                  <Row className="mb-4">
                    {contactFields.map((item, index) => (
                      <Row key={item.id || index}>
                        <Col lg="3" xs={12} md={5} sm={12}>
                          <FormGroup className="mb-4">
                            <Label>Contact Name</Label>
                            <UFInput
                              control={control}
                              placeholder="Enter the Contact Name"
                              name={`contact_person.${index}.supplier_contact_name`}
                              invalid={
                                !!errors?.contact_person?.[index]
                                  ?.supplier_contact_name
                              }
                            />
                            <FormFeedback invalid>
                              {
                                errors.contact_person?.[index]
                                  ?.supplier_contact_name?.message
                              }
                            </FormFeedback>
                          </FormGroup>
                        </Col>
                        <Col lg="3" xs={12} md={5} sm={12}>
                          <FormGroup className="mb-4">
                            <Label>Contact Email ID</Label>
                            <UFInput
                              control={control}
                              placeholder="Enter the Contact Email ID"
                              rows="3"
                              name={`contact_person.${index}.email_id`}
                              invalid={
                                !!errors?.contact_person?.[index]?.email_id
                              }
                            />
                            <FormFeedback invalid>
                              {
                                errors.contact_person?.[index]?.email_id
                                  ?.message
                              }
                            </FormFeedback>
                          </FormGroup>
                        </Col>
                        <Col lg="3" xs={12} md={5} sm={12}>
                          <FormGroup className="mb-4">
                            <Label>Contact Designation</Label>
                            <UFInput
                              control={control}
                              placeholder="Enter the Contact Designation"
                              name={`contact_person.${index}.designation`}
                              invalid={
                                !!errors?.contact_person?.[index]?.designation
                              }
                            />
                            <FormFeedback invalid>
                              {
                                errors.contact_person?.[index]?.designation
                                  ?.message
                              }
                            </FormFeedback>
                          </FormGroup>
                        </Col>
                        <Col lg="3" xs={12} md={5} sm={12}>
                          <FormGroup className="mb-4">
                            <Label>Contact Phone Number</Label>
                            {/* <UFInput
                              control={control}
                              placeholder="Enter the Contact Phone number"
                              name={`contact_person.${index}.phone_no`}
                              invalid={
                                !!errors?.contact_person?.[index]?.phone_no
                              }
                            /> */}
                            <PhoneInputField
                              control={control}
                              name={`contact_person.${index}.phone_no`}
                              invalid={
                                !!errors.contact_person?.[index]?.phone_no
                              }
                            />
                            <FormFeedback invalid>
                              {
                                errors.contact_person?.[index]?.phone_no
                                  ?.message
                              }
                            </FormFeedback>
                          </FormGroup>
                        </Col>
                        <Col
                          lg="12"
                          xs={12}
                          md={2}
                          sm={12}
                          className="d-flex justify-content-end"
                        >
                          {contactFields.length > 1 ? (
                            <Button
                              color="secondary"
                              className="removeButton mt-2 ms-3"
                              onClick={() => contactRemove(index)}
                            >
                              <TrashIcon />
                            </Button>
                          ) : (
                            ""
                          )}
                          {contactFields.length == index + 1 ? (
                            <Button
                              color="primary"
                              className="addButton mt-2 ms-3"
                              onClick={() =>
                                contactAppend({
                                  email_id: "",
                                  designation: "",
                                  phone_no: "",
                                  name: "",
                                })
                              }
                            >
                              + Row
                            </Button>
                          ) : (
                            ""
                          )}
                        </Col>
                      </Row>
                    ))}
                  </Row>
                  {/* <hr className="m-0" /> */}
                  <Row className="py-2 mb-2">
                    {/* <h5>Bank Details</h5> */}
                    <div className="d-flex align-items-center">
                      <div className="text-extra-high fw-500 font-16 wdt-12">
                        Bank Details
                      </div>
                      <div className="w-100 div-line"></div>
                    </div>
                  </Row>
                  <Row className="mb-4">
                    {accountFields.map((item, index) => (
                      <Row key={item.id || index}>
                        <Col lg="3" xs={12} md={5} sm={12}>
                          <FormGroup className="mb-4">
                            <Label>
                              Account Holder Name
                              {/* <span className="mandatory">*</span> */}
                            </Label>
                            <UFInput
                              control={control}
                              placeholder="Enter the Account Holder Name"
                              name={`bank_details.${index}.ac_holder_name`}
                              invalid={
                                !!errors?.bank_details?.[index]?.ac_holder_name
                              }
                            />
                            <FormFeedback invalid>
                              {
                                errors?.bank_details?.[index]?.ac_holder_name
                                  ?.message
                              }
                            </FormFeedback>
                          </FormGroup>
                        </Col>
                        <Col lg="3" xs={12} md={5} sm={12}>
                          <FormGroup className="mb-4">
                            <Label>
                              Account Number
                              {/* <span className="mandatory">*</span> */}
                            </Label>
                            <UFInput
                              control={control}
                              placeholder="Enter the Account Number"
                              name={`bank_details.${index}.ac_number`}
                              invalid={
                                !!errors?.bank_details?.[index]?.ac_number
                              }
                            />
                            <FormFeedback invalid>
                              {errors.bank_details?.[index]?.ac_number?.message}
                            </FormFeedback>
                          </FormGroup>
                        </Col>
                        <Col lg="3" xs={12} md={5} sm={12}>
                          <FormGroup className="mb-4">
                            <Label>
                              Bank Name
                              {/* <span className="mandatory">*</span> */}
                            </Label>
                            <BankList
                              control={control}
                              placeholder="Enter the Bank Name"
                              name={`bank_details.${index}.bank_name`}
                              onSelectChange={e => handleBank(e, index)}
                            />
                            {/* <UFInput
                              control={control}
                              placeholder="Enter the Bank Name"
                              name={`bank_details.${index}.bank_name`}
                              invalid={
                                !!errors?.bank_details?.[index]?.bank_name
                              }
                            /> */}
                            <FormFeedback invalid>
                              {errors.bank_details?.[index]?.bank_name?.message}
                            </FormFeedback>
                          </FormGroup>
                        </Col>
                        <Col lg="3" xs={12} md={5} sm={12}>
                          <FormGroup className="mb-4">
                            <Label>
                              Branch Name
                              {/* <span className="mandatory">*</span> */}
                            </Label>
                            <UFInput
                              control={control}
                              placeholder="Enter the Branch Name"
                              name={`bank_details.${index}.branch_name`}
                              invalid={
                                !!errors?.bank_details?.[index]?.branch_name
                              }
                            />
                            <FormFeedback invalid>
                              {
                                errors.bank_details?.[index]?.branch_name
                                  ?.message
                              }
                            </FormFeedback>
                          </FormGroup>
                        </Col>
                        <Col lg="3" xs={12} md={5} sm={12}>
                          <FormGroup className="mb-4">
                            <Label>
                              IBAN
                              {/* <span className="mandatory">*</span> */}
                            </Label>
                            <UFInput
                              control={control}
                              placeholder="Enter the IBAN Name"
                              name={`bank_details.${index}.iban`}
                              invalid={!!errors?.bank_details?.[index]?.iban}
                            />
                            <FormFeedback invalid>
                              {errors.bank_details?.[index]?.iban?.message}
                            </FormFeedback>
                          </FormGroup>
                        </Col>
                        <Col lg="3" xs={12} md={5} sm={12}>
                          <FormGroup className="mb-4">
                            <Label>
                              SWIFT/BIC Code
                              {/* <span className="mandatory">*</span> */}
                            </Label>
                            <UFInput
                              control={control}
                              placeholder="Enter the Swift/Bic Code"
                              name={`bank_details.${index}.swift_code`}
                              invalid={
                                !!errors?.bank_details?.[index]?.swift_code
                              }
                            />
                            <FormFeedback invalid>
                              {
                                errors.bank_details?.[index]?.swift_code
                                  ?.message
                              }
                            </FormFeedback>
                          </FormGroup>
                        </Col>
                        {/* <Col
                          lg="12"
                          xs={12}
                          md={2}
                          sm={12}
                          className="d-flex justify-content-end"
                        >
                          {accountFields.length > 1 ? (
                            <Button
                              color="secondary"
                              className="removeButton mt-2 ms-3"
                              onClick={() => accountRemove(index)}
                            >
                              <TrashIcon />
                            </Button>
                          ) : (
                            ""
                          )}
                          {accountFields.length == index + 1 ? (
                            <Button
                              color="primary"
                              className="addButton mt-2 ms-3"
                              onClick={() =>
                                accountAppend({
                                  ac_holder_name: "",
                                  ac_number: "",
                                  bank_name: null,
                                  branch_name: "",
                                  iban: "",
                                  swift_code: "",
                                })
                              }
                            >
                              + Row
                            </Button>
                          ) : (
                            ""
                          )}
                        </Col> */}
                      </Row>
                    ))}
                  </Row>
                </Card>
              </Container>
              <Modal
                isOpen={isModal}
                toggle={toggleSelect}
                size="xl"
                unmountOnClose={false}
                className="custom-modal-ht"
                backdrop={"static"}
              >
                <div>
                  {/* <div onKeyDown={onKeyDown}> */}
                  <ModalHeader className="custom-modal-header">
                    <div className="d-flex justify-content-between">
                      <h5 className="ms-2">Opening Balance Details </h5>
                      <img
                        src={closeIcon}
                        alt=""
                        onClick={toggleSelectModal}
                        width="10"
                        role="button"
                      />
                    </div>
                  </ModalHeader>
                  <ModalBody>
                    <Row className="mb-4">
                      <Col lg={12} className="mb-4">
                        <table className="estimation-table mb-4">
                          <thead>
                            <tr>
                              <th>Dr/Cr</th>
                              <th>Reference</th>
                              <th>Date</th>
                              <th>Due Date</th>
                              <th>Amount</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {contraFieldsPartial?.map((item, index) => (
                              <>
                                <tr key={`purchase${item.id || index}`}>
                                  <td>
                                    <FormGroup>
                                      <DebitCreditDrop
                                        control={control}
                                        placeholder="Select"
                                        name={`voucher_contra_partial_pay.${index}.type`}
                                        ref={el => (drCrRefs.current[index] = el)}
                                      />
                                      <FormFeedback invalid>
                                        {
                                          errors.voucher_contra_partial_pay?.[index]
                                            ?.type?.message
                                        }
                                      </FormFeedback>
                                    </FormGroup>
                                  </td>
                                  <td>
                                    <FormGroup>
                                      <UFInput
                                        control={control}
                                        placeholder="Code"
                                        name={`voucher_contra_partial_pay.${index}.code`}
                                        className="ps-1"
                                      />
                                      <FormFeedback invalid>
                                        {
                                          errors.voucher_contra_partial_pay?.[index]
                                            ?.code?.message
                                        }
                                      </FormFeedback>
                                    </FormGroup>
                                  </td>
                                  <td>
                                    <FormGroup>
                                      <UFDate
                                        control={control}
                                        placeholder="Select Date"
                                        name={`voucher_contra_partial_pay.${index}.date`}
                                        className="ps-1"
                                      />
                                      <FormFeedback invalid>
                                        {
                                          errors.voucher_contra_partial_pay?.[index]
                                            ?.date?.message
                                        }
                                      </FormFeedback>
                                    </FormGroup>
                                  </td>
                                  <td>
                                    <FormGroup>
                                      <UFDate
                                        control={control}
                                        placeholder="Select Date"
                                        name={`voucher_contra_partial_pay.${index}.due_date`}
                                        className="ps-1"
                                      />
                                      <FormFeedback invalid>
                                        {
                                          errors.voucher_contra_partial_pay?.[index]
                                            ?.due_date?.message
                                        }
                                      </FormFeedback>
                                    </FormGroup>
                                  </td>
                                  <td>
                                    <FormGroup>
                                      <UFInputNumber
                                        control={control}
                                        placeholder="Amount"
                                        name={`voucher_contra_partial_pay.${index}.amount`}
                                        className="ps-1"
                                        isDecimal={true}
                                        decimalLength={desimalrange || 2}
                                      />
                                      <FormFeedback invalid>
                                        {
                                          errors.voucher_contra_partial_pay?.[index]
                                            ?.amount?.message
                                        }
                                      </FormFeedback>
                                    </FormGroup>
                                  </td>
                                  <td>
                                    <div className="pb-1 px-2 d-flex justify-content-center">
                                      <div
                                        className="trash-img pointer"
                                        onClick={() => {
                                          contraPartialListRemove(index)
                                          handlePartialRemove(item?.voucher_entry_id)
                                        }}
                                      >
                                        <TrashIcon />
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </>
                            ))}
                          </tbody>
                        </table>
                        <Row>
                          <Col lg="6"></Col>
                          <Col lg="3" className="py-2">
                            <div className="text-end">Total</div>
                          </Col>
                          <Col lg="3" className="py-2">
                            {Number(watch("opening_balance")).toFixed(
                              desimalrange || 2
                            )}
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6"></Col>
                          <Col lg="3" className="py-2">
                            <div className="text-end">Debit</div>
                          </Col>
                          <Col lg="3" className="py-2">
                            {Number(
                              calculateCreditDebitDifference(
                                watch("voucher_contra_partial_pay") || []
                              )?.totalDebit
                            ).toFixed(desimalrange || 2)}
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6"></Col>
                          <Col lg="3" className="py-2">
                            <div className="text-end">Credit</div>
                          </Col>
                          <Col lg="3" className="py-2">
                            {Number(
                              calculateCreditDebitDifference(
                                watch("voucher_contra_partial_pay") || []
                              )?.totalCredit
                            ).toFixed(desimalrange || 2)}
                          </Col>
                        </Row>
                        {/* {[13, 15, 6, 1, 3, 8].includes(watch("voucher_id")?.value) && ( */}
                        {/* <div className="text-end mt-2 note-txt">
                                  Press TAB to handle Values
                                </div> */}
                        {/* )} */}
                      </Col>
                      {/* <Col lg="12">
                              {viewVouchersLi ? (
                                <VoucherEntrySearch
                                  fromDashboard={true}
                                  editPartial={editPartial} // Added by Adithyan
                                  editId={editId} // Added by Adithyan
                                  handilUpdate={handilUpdate} // Added by Adithyan
                                  onSelect={handlePOSelect}
                                  voucherType={viewData?.voucher_type}
                                  ledgerId={viewData?.ledger_id}
                                  partialPayment={true}
                                  voucherLocation={watch("voucher_id")?.value}
                                />
                              ) : (
                                <></>
                              )}
                            </Col> */}
                    </Row>
                  </ModalBody>
                  <ModalFooter>
                    <LoadingButton
                      form={formId}
                      color={"primary"}
                      loading={isLoading}
                      disabled={isLoading}
                      type="submit"
                    >
                      Save
                    </LoadingButton>
                  </ModalFooter>
                </div>
              </Modal>
            </Form>
          </FormProvider>
        </div>
      </div>
    </React.Fragment>
  )
}

export default EditSupplier
